/* ============================================================
   GG CURRENCY — move the currency selector into the footer.

   The app (bacurr) injects a position:fixed pill in a screen corner. Shopify's
   own country/language selector guidance puts this control in the header, footer
   or nav drawer; floating, it also covered the homepage hero's call to action.

   We RELOCATE the app's own widget rather than hide it and build our own: it
   owns the rates, the conversion and the cart notice.

   Targeted by class now that the real markup is known. An earlier version tried
   to find it by behaviour (a small fixed element whose text is a currency code)
   and failed: the container's textContent holds EVERY option, so it read as
   "Euro (EUR)US Dollar (USD)British Pound (GBP)…" — far too long to match.
   ============================================================ */
(function () {
  'use strict';

  var WIDGET = '.bacurr-dropdownChoices';
  // The app sets these as inline custom properties WITH !important, which no
  // stylesheet can beat — they have to be removed in JS for our CSS to apply.
  var INLINE_VARS = ['--bacurrBackground', '--bacurrSelect-color', '--bacurrHover-bg'];
  var tries = 0;

  function slot() { return document.querySelector('[data-gg-currency-slot]'); }

  function relocate() {
    var host = slot();
    if (!host) return true;                       // not a page with a footer slot
    if (host.querySelector(WIDGET)) return true;  // already moved
    var el = document.querySelector(WIDGET);
    if (!el) return false;

    // Remember the fixed wrapper before moving, so the empty shell can be hidden.
    var fixed = null;
    var p = el.parentElement;
    while (p && p !== document.body) {
      if (window.getComputedStyle(p).position === 'fixed') { fixed = p; break; }
      p = p.parentElement;
    }

    host.appendChild(el);
    INLINE_VARS.forEach(function (v) { el.style.removeProperty(v); });
    ['position', 'top', 'right', 'bottom', 'left', 'margin', 'zIndex', 'boxShadow']
      .forEach(function (prop) { el.style.removeProperty(prop); });
    el.classList.add('gg-currency-moved');

    if (fixed && !fixed.querySelector(WIDGET)) { fixed.style.display = 'none'; }

    wireToggle(el);
    return true;
  }

  /* The app's open/close behaviour is driven by CSS scoped to its own fixed
     wrapper, so once the widget is reparented the list is permanently visible and
     the native <select> reappears. We therefore own the toggle: a .gg-open class
     on the container, which §35 keys off. The app's own click handlers on the
     <li> elements are bound to the elements themselves, so switching currency
     still works untouched. */
  function wireToggle(el) {
    if (el.dataset.ggWired) return;
    el.dataset.ggWired = '1';

    var trigger = el.querySelector('.bacurr-choiceDesign');
    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        el.classList.toggle('gg-open');
      });
    }
    // Close after a choice — the app updates the label itself.
    el.querySelectorAll('.bacurr-dropdown-choices li').forEach(function (li) {
      li.addEventListener('click', function () { el.classList.remove('gg-open'); });
    });
    document.addEventListener('click', function (e) {
      if (!el.contains(e.target)) { el.classList.remove('gg-open'); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { el.classList.remove('gg-open'); }
    });
  }

  function start() {
    if (relocate()) return;
    // The app injects after its own script loads, so retry on a decaying
    // schedule rather than a tight interval.
    if (++tries > 12) {
      // Give up gracefully: CSS hides the widget until it is moved, so without
      // this the control would stay invisible forever if the app ever changes
      // its markup.
      var orphan = document.querySelector(WIDGET);
      if (orphan) { orphan.classList.add('gg-currency-fallback'); }
      return;
    }
    setTimeout(start, 250 * tries);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function () { tries = 0; start(); });
})();
